import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'add-picture-modal',
  templateUrl: './add-picture.component.html',
  styleUrls: ['./add-picture.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})

export class AddPictureComponent implements OnInit {
  file;
  newImage;
  constructor(public dialogRef: MatDialogRef<AddPictureComponent>,
              @Inject(MAT_DIALOG_DATA) private data: any) {
    if (this.data?.event) {
      this.file = this.data.event;
    }
  }

  ngOnInit() {

  }

  setImg(event: any) {
    this.newImage = event;
  }
}
